<template>
  <div class="orders-list-wrap">
    <div v-if="!safeItems.length" class="orders-empty">
      <i class="bi bi-bag"></i>
      <p class="mb-0">سفارشی برای نمایش وجود ندارد.</p>
    </div>

    <div v-else>
      <div class="d-lg-none">
        <article
          v-for="item in safeItems"
          :key="'card-' + item.id"
          class="order-card"
        >
          <div class="order-card-top">
            <span v-if="showFieldManager('table-field-order-id')" class="order-id-chip table-field-order-id">
              #{{ item.id }}
            </span>
            <div v-if="showFieldManager('table-field-order-price')" class="order-amount table-field-order-price">
              {{ formatNumber(item.paying_amount) }}
            </div>
          </div>

          <div class="order-card-identity">
            <h4 v-if="showFieldManager('table-field-order-user')" class="order-card-user table-field-order-user">
              {{ userFullName(item) }}
            </h4>
            <span
              v-if="showFieldManager('table-field-order-payment-status')"
              class="order-badge table-field-order-payment-status"
              :class="paymentBadgeClass(item)"
            >
              {{ paymentStatusName(item) }}
            </span>
          </div>

          <div class="order-card-flags">
            <span
              v-if="showFieldManager('table-field-order-in-out')"
              class="order-badge table-field-order-in-out"
              :class="orderInOutType(item) == 'ورودی' ? 'is-in' : 'is-out'"
            >
              {{ orderInOutType(item) }}
            </span>
            <holoo-status v-if="showFieldManager('table-field-order-in-out')" :item="item"/>
            <div v-if="showFieldManager('table-field-order-status')" class="order-status-wrap table-field-order-status">
              <select
                v-if="canChangeStatus(item)"
                class="order-status-select"
                v-model="item.status.status_id"
                @change="setDataForChangeOrderStatus(item)"
              >
                <option
                  class="text-dark"
                  v-for="(order_status_item, index) in getOrderStatus"
                  v-if="index > 0"
                  :key="'status-' + item.id + '-' + index"
                  :value="index"
                >
                  {{ order_status_item }}
                </option>
              </select>
              <span v-else>{{ statusName(item) }}</span>
            </div>
          </div>

          <div class="order-card-meta">
            <div v-if="showFieldManager('table-field-order-created-at')" class="order-meta-box table-field-order-created-at">
              <span>تاریخ ساخت</span>
              <strong dir="ltr" v-html="addEnterBetweenDateAndTime(item.created_at)"></strong>
            </div>
            <div v-if="showFieldManager('table-field-order-updated-at')" class="order-meta-box table-field-order-updated-at">
              <span>به‌روزرسانی</span>
              <strong dir="ltr" v-html="addEnterBetweenDateAndTime(item.updated_at)"></strong>
            </div>
            <div v-if="showFieldManager('table-field-order-payment-date')" class="order-meta-box table-field-order-payment-date">
              <span>تاریخ پرداخت</span>
              <strong v-if="item.transaction != null" dir="ltr" v-html="addEnterBetweenDateAndTime(item.transaction.updated_at)"></strong>
              <strong v-else>—</strong>
            </div>
            <div
              v-if="showFieldManager('table-field-order-actions')"
              class="order-meta-box order-meta-actions"
            >
              <span>عملیات</span>
              <order-item-actions
                :item="item"
                :show-actions="true"
                :show-comment="false"
              />
            </div>
          </div>

          <div
            v-if="showFieldManager('table-field-order-items') && orderItemsList(item).length"
            class="order-items-list table-field-order-items"
          >
            <p v-for="(order_item, idx) in orderItemsList(item)" :key="item.id + '-item-' + idx">
              {{ orderItemName(order_item) }} (تعداد: {{ order_item.quantity }})
            </p>
          </div>

          <div
            v-if="showFieldManager('table-field-order-description') && manageOrderDescription(item)"
            class="order-items-list table-field-order-description"
          >
            <span v-html="manageOrderDescription(item)"></span>
          </div>

        </article>
      </div>

      <div class="table-responsive d-none d-lg-block">
        <table class="text-center orders-table">
          <thead>
          <tr>
            <th v-if="showFieldManager('table-field-order-id')" class="table-field-order-id">
              <order-table-filter filter-column="id">شناسه سبد</order-table-filter>
            </th>
            <th v-if="showFieldManager('table-field-order-user')" class="table-field-order-user">کاربر</th>
            <th v-if="showFieldManager('table-field-order-price')" class="table-field-order-price">
              <order-table-filter filter-column="paying_amount">پرداختی</order-table-filter>
            </th>
            <th v-if="showFieldManager('table-field-order-payment-status')" class="table-field-order-payment-status">
              وضعیت پرداخت
            </th>
            <th v-if="showFieldManager('table-field-order-in-out')" class="table-field-order-in-out">نوع سفارش</th>
            <th v-if="showFieldManager('table-field-order-status')" class="table-field-order-status">وضعیت سبد</th>
            <th v-if="showFieldManager('table-field-order-created-at')" class="table-field-order-created-at">
              <order-table-filter filter-column="created_at">تاریخ ساخت</order-table-filter>
            </th>
            <th v-if="showFieldManager('table-field-order-updated-at')" class="table-field-order-updated-at">
              <order-table-filter filter-column="updated_at">تاریخ به روزرسانی</order-table-filter>
            </th>
            <th v-if="showFieldManager('table-field-order-payment-date')" class="table-field-order-payment-date">
              تاریخ پرداخت
            </th>
            <th v-if="showFieldManager('table-field-order-items')" class="table-field-order-items">ایتم ها</th>
            <th v-if="showFieldManager('table-field-order-description')" class="table-field-order-description">
              توضیحات سفارش
            </th>
            <th v-if="showFieldManager('table-field-order-actions')" class="table-field-order-actions">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in safeItems" :key="'row-' + item.id">
            <td v-if="showFieldManager('table-field-order-id')" class="table-field-order-id">
              <span class="order-id-chip">{{ item.id }}</span>
            </td>
            <td v-if="showFieldManager('table-field-order-user')" class="table-field-order-user">
              <span class="text-wrap">{{ userFullName(item) }}</span>
            </td>
            <td v-if="showFieldManager('table-field-order-price')" class="table-field-order-price">
              <span class="order-amount">{{ formatNumber(item.paying_amount) }}</span>
            </td>
            <td v-if="showFieldManager('table-field-order-payment-status')" class="table-field-order-payment-status">
              <span class="order-badge" :class="paymentBadgeClass(item)">{{ paymentStatusName(item) }}</span>
            </td>
            <td v-if="showFieldManager('table-field-order-in-out')" class="table-field-order-in-out">
              <span
                class="order-badge"
                :class="orderInOutType(item) == 'ورودی' ? 'is-in' : 'is-out'"
              >{{ orderInOutType(item) }}</span>
              <holoo-status :item="item"/>
            </td>
            <td v-if="showFieldManager('table-field-order-status')" class="table-field-order-status">
              <select
                v-if="canChangeStatus(item)"
                class="order-status-select"
                v-model="item.status.status_id"
                @change="setDataForChangeOrderStatus(item)"
              >
                <option
                  class="text-dark"
                  v-for="(order_status_item, index) in getOrderStatus"
                  v-if="index > 0"
                  :key="'row-status-' + item.id + '-' + index"
                  :value="index"
                >
                  {{ order_status_item }}
                </option>
              </select>
              <span v-else>{{ statusName(item) }}</span>
            </td>
            <td v-if="showFieldManager('table-field-order-created-at')" class="table-field-order-created-at">
              <span v-html="addEnterBetweenDateAndTime(item.created_at)" dir="ltr"></span>
            </td>
            <td v-if="showFieldManager('table-field-order-updated-at')" class="table-field-order-updated-at">
              <span v-html="addEnterBetweenDateAndTime(item.updated_at)" dir="ltr"></span>
            </td>
            <td v-if="showFieldManager('table-field-order-payment-date')" class="table-field-order-payment-date">
              <span
                v-if="item.transaction != null"
                v-html="addEnterBetweenDateAndTime(item.transaction.updated_at)"
                dir="ltr"
              ></span>
            </td>
            <td v-if="showFieldManager('table-field-order-items')" class="table-field-order-items">
              <p v-for="(order_item, idx) in orderItemsList(item)" :key="item.id + '-row-item-' + idx" class="d-block my-2 mb-0">
                {{ orderItemName(order_item) }} (تعداد: {{ order_item.quantity }})
              </p>
            </td>
            <td v-if="showFieldManager('table-field-order-description')" class="table-field-order-description">
              <span v-html="manageOrderDescription(item)"></span>
            </td>
            <td v-if="showFieldManager('table-field-order-actions')" class="table-field-order-actions">
              <order-item-actions :item="item" :show-comment="false"/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {order_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import OrderTableFilter from "@/plugin/components/dashboard/orders/OrderTableFilter.vue";
import HolooStatus from "../Holoo/components/HolooStatus.vue";
import OrderItemActions from "./OrderItemActions.vue";
import "./orders-ui.css";

export default {
  name: "tableItemOfOrders",
  components: {OrderItemActions, HolooStatus, OrderTableFilter, FormGroup, FormErrorsManager},
  props: {
    items: {
      default: () => []
    },
    restoreState: {},
    activeTableField: {
      default: '*'
    }
  },
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه سبد"},
        {key: "user", label: "کاربر"},
        {key: "paying_amount", label: "پرداختی"},
        {key: "payment_status", label: "وضعیت پرداخت"},
        {key: "status", label: "وضعیت سبد"},
        {key: "shopping_cart_created_at", label: "تاریخ ساخت سبد"},
        {key: "shopping_cart_updated_at", label: "تاریخ به روزرسانی"},
        {key: "transaction_date", label: "تاریخ پرداخت"},
        {key: "items", label: "ایتم های سفارش"},
        {key: "action", label: ""},
        {key: "comment", label: "نظر دادن"}
      ],
      order_status,
      order_id: '',
      commentForm: {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        [{color: []}]
      ],
      filter: {
        currentFilterName: '',
        filterType: 'asc'
      }
    };
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin',
      isUserStore: 'User/isUserStore',
    }),
    getOrderStatus() {
      return this.order_status;
    },
    safeItems() {
      return Array.isArray(this.items) ? this.items : [];
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeOrderStatus(item) {
      const order_id = item.id;
      const status = item.status.status_id;
      this.changeOrderStatus({order_id, status});
    },
    formatNumber,
    dateConverter,
    addEnterBetweenDateAndTime(date) {
      if (!date) {
        return '—';
      }
      date = this.dateConverter(date, '/', true);
      return date.replace(' ', '<br>');
    },
    setOrderId(id) {
      this.order_id = id;
      this.commentForm.commentable_id = id;
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1;
      }
      this.$store.dispatch("Comment/createComment", this.commentForm).then(() => {
        toast('', 'کامنت شما با موفقیت ثبت شد و در انتظار برای تایید قرار گرفت');
      });
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      };
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault();
      if (this.invalid()) {
        this.createComment();
        this.$nextTick(() => {
          this.$bvModal.hide('comment-' + this.order_id);
          this.resetCommentForm();
        });
      }
    },
    manageOrderDescription(item) {
      let orderDescription = item && item.description;
      if (!orderDescription) {
        return '';
      }
      try {
        let descriptionJson = JSON.parse(orderDescription);
        let result = "";
        for (let key in descriptionJson) {
          result += `${key}: ${descriptionJson[key]} <br>`;
        }
        return result;
      } catch (e) {
        return orderDescription;
      }
    },
    showFieldManager(fieldName) {
      if (this.activeTableField === '*') return true;
      return this.activeTableField.indexOf(fieldName) > -1;
    },
    orderInOutType(order) {
      let meta = order && order.meta;
      let result = "فروش";
      if (!Array.isArray(meta)) {
        return result;
      }
      meta.forEach(item => {
        if (item.name == 'order_in_out_flag' && item.value == 1) {
          result = "ورودی";
        }
      });
      return result;
    },
    userFullName(item) {
      if (!item || !item.user) {
        return '—';
      }
      const name = ((item.user.name || '') + ' ' + (item.user.last_name || '')).trim();
      return name || '—';
    },
    orderItemsList(item) {
      return item && Array.isArray(item.items) ? item.items : [];
    },
    orderItemName(orderItem) {
      return orderItem && orderItem.product && orderItem.product.name ? orderItem.product.name : 'محصول';
    },
    paymentStatusName(item) {
      return item && item.payment_status && item.payment_status.status_name ? item.payment_status.status_name : '—';
    },
    paymentBadgeClass(item) {
      const statusId = item && item.payment_status ? item.payment_status.status_id : null;
      return statusId == 2 ? 'is-paid' : 'is-unpaid';
    },
    statusName(item) {
      return item && item.status && item.status.status_name ? item.status.status_name : '—';
    },
    canChangeStatus(item) {
      return item &&
        item.payment_status &&
        item.payment_status.status_id == 2 &&
        item.status &&
        (this.isAdmin || this.isUserStore);
    }
  },
};
</script>
